<div class="wrap-x wrap-l wrap-m p-t-5 p-b-5 p-t-6-s p-b-6-s"
     sizeClass="XLM:_custom-wrap">
    @for (block of component.blocks; track $index) {
    <div [ngClass]="block.variant === '1-column' ? 'w-6 w-12-s' : 'w-12'">
        <div class="position-relative m-a-5 m-a-3-m m-l-0-s m-r-0-s m-t-2-s m-b-2-s b-radius-4 overflow-hidden"
             [ngClass]="block.variant === '1-column' || client.isS ? 'ratio-3-2' : 'ratio-3-1'">
            <div class="pos-absolute top-0 left-0 right-0 bottom-0 z-1 bg-col-1"
                 [style.opacity.%]="block?.overlay || 0"></div>
            <href [link]="block.imageLink"
                  [hrefClass]="'fill z-2'">
                <shell />
                <img class="b-radius-4"
                     [fill]="true"
                     [ratio]="block.variant === '1-column' || client.isS ? 'ratio-3-2' : 'ratio-3-1'"
                     [dfImage]="block.backgroundImage">
            </href>
            <div class="pos-absolute top-0 left-0 right-0 z-2"
                 style="max-width: 400px;">
                <text class="block bg-col-w bg-col-t-m bg-col-t-s p-a-5 m-a-5 m-a-0-m p-a-4-m m-a-0-s p-a-4-s b-radius-4"
                      [content]="block"></text>
            </div>
        </div>
    </div>
    }
</div>
